/**
 * TYPES
 */
import {IAiState} from 'src/aggregates/ai/state.d';


/**
 * CODE
 */

/**
 * AI initial state.
 */
const initialState: IAiState = {
    agents: {},
    hasAddToTrainingError: false,
    hasDeleteUnansweredError: false,
    hasError: false,
    hasImplantError: false,
    hasLoadingOneError: false,
    hasUpdateError: false,
    isAddingToTraining: false,
    isDeletingUnanswered: false,
    isImplanting: false,
    isLoading: false,
    isLoadingOne: false,
    isUpdating: false,
};


/**
 * EXPORTS
 */
export default initialState;
